module.exports = require('./lib/storage');